import * as React from 'react';
import { useDebouncedCallback } from 'use-debounce';

/**
 * Creates a debounced function that will trigger on unmount when pending
 */
export const useFlushedDebouncedCallback: typeof useDebouncedCallback = (
  callback,
  wait,
  options
) => {
  const debouncedCallback = useDebouncedCallback(callback, wait, options);

  // When unmounting with a pending callback, make sure it's flushed
  React.useEffect(() => () => debouncedCallback.flush(), [debouncedCallback]);

  return debouncedCallback;
};
